(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraController', ModelosdeimpresoraController);

    ModelosdeimpresoraController.$inject = ['Modelosdeimpresora'];

    function ModelosdeimpresoraController(Modelosdeimpresora) {

        var vm = this;

        vm.modelosdeimpresoras = [];

        loadAll();

        function loadAll() {
            Modelosdeimpresora.query(function(result) {
                vm.modelosdeimpresoras = result;
                vm.searchQuery = null;
            });
        }
    }
})();
